import { Row, Col, Button, ListGroup } from "react-bootstrap";
import { default as React } from "react";
import { PacmanLoader } from "react-spinners";
import { GenericTable } from "components/GenericTable";
import EditableCell from "containers/common/EditableCell";
import "containers/common/List.css";
import "containers/common/Table.css";

import {
  createColumnHelper,
} from "@tanstack/react-table";

function SaleSheetClassificationList({
  data,
  isLoading,
  isAuthenticated,
  controlType,
  classificationOptions,
  saveRecord,
  deleteRecord,
  updateTableState,
  user,
  salesheetid,
}) {

  const dataSet = 'saleSheetClassifications';
  // const [dataSetPrimaryKey,] = useState("sale_sheet_classification_id");

  // --- TanStack Table Setup ---
  const tableData = data || [];
  const columnHelper = createColumnHelper();

  function updateRowData(rowIndex, columnId, value) {
    const localData = [...tableData];
    if (!localData[rowIndex]) {
      return;
    }

    const selectedClassification = columnId === "classification_code"
      ? (classificationOptions || []).find((opt) => String(opt?.value ?? "") === String(value ?? ""))
      : null;

    localData[rowIndex] = {
      ...localData[rowIndex],
      [columnId]: value,
      ...(selectedClassification
        ? { classification: selectedClassification.label }
        : {}),
      modified: true,
    };

    updateTableState(localData, dataSet);
  }

  async function handleSave({ row, column, value }) {
    const rowIndex = row?.index;
    const currentRecord = Number.isInteger(rowIndex) && tableData[rowIndex]
      ? tableData[rowIndex]
      : (row?.original || {});

    const selectedClassification = column?.id === "classification_code"
      ? (classificationOptions || []).find((opt) => String(opt?.value ?? "") === String(value ?? ""))
      : null;

    const record = {
      ...currentRecord,
      ...(column?.id ? { [column.id]: value } : {}),
      ...(selectedClassification ? { classification: selectedClassification.label } : {}),
      modified: true,
    };

    try {
      const result = await saveRecord(record, dataSet, "sale_sheet_classification_id");

      const resolvedId = result?.id ?? result?.sale_sheet_classification_id;
      if (Number.isInteger(rowIndex) && tableData[rowIndex]) {
        const localData = [...tableData];
        localData[rowIndex] = {
          ...record,
          ...(resolvedId ? { sale_sheet_classification_id: resolvedId } : {}),
          new_record: resolvedId ? false : Boolean(record.new_record),
          modified: false,
        };
        updateTableState(localData, dataSet);
      }

      console.log("Record saved successfully via parent logic");
      return true;
    } catch (err) {
      console.error("Save failed:", err);
      return false;
    }
  }

  async function handleDelete({ row }) {
    const confirmed = window.confirm("Are you sure you want to delete this record?");
    if (!confirmed) {
      return;
    }

    const record = {
      ...row.original,
      archived_date: new Date().toISOString(),
      last_edited_by: user,
    };

    try {
      await saveRecord(record, dataSet, "sale_sheet_classification_id");
      const localData = tableData.filter((_, index) => index !== row.index);
      updateTableState(localData, dataSet);
    } catch (err) {
      console.error("Delete failed:", err);
    }
  }

  const columns = [
    columnHelper.accessor("sale_sheet_classification_id", {
      id: "sale_sheet_classification_id",
      header: "ID",
      size: 60,
    }),
    columnHelper.accessor("classification_code", {
      id: "classification_code",
      header: "Classification",
      cell: EditableCell,
      meta: {
        options: classificationOptions || [],
        useClearableSingleSelect: true,
        saveOnBlurOnly: false,
      },
    }),
    columnHelper.accessor("sale_sheet_classification_id", {
      id: "sale_sheet_classification_id",
      header: "",
      cell: (e) =>
        <Button type="button" size="sm" variant="danger" onClick={() => handleDelete({ row: e.row })}>
          Delete
        </Button>,
      size: 65,
    }),
  ];

  // --- Data Fetching and Update Functions ---
  async function addRecord(event) {
    let localData = [...data];
    //Minimum record to create (all not nulls populated)
    localData.unshift({
      sale_sheet_id: salesheetid,
      classification_code: "",
      classification: "",
      created_by: user,
      last_edited_by: user,
      new_record: true
    });
    updateTableState(localData, dataSet);
  }

  // --- Render Functions ---
  function renderList(data) {
    if (!data) {
      return null
    }
    else {
      return [{}].concat(data).map(
        (d, i) =>
          i !== 0
            ?
            <ListGroup.Item key={i} as="a" header={d.classification}>
              {d.classification}
            </ListGroup.Item>
            : ""
      );
    }
  }

  function renderComponent() {
    return (
      <div className="componentRendering">
        {controlType === "table" && <Row className="show-Container">
          <Col className="text-right" >
            <Button variant="secondary" size="sm" onClick={addRecord}
            >Add</Button>
          </Col>
        </Row>}

        <Row className="show-Container">
          <Col sm={12} md={12} lg={12}>
            {isLoading ? (
              <div className="outer-div">
                <div className="sweet-loading inner-div">
                  <PacmanLoader
                    cssOverride={{ display: "block", margin: "0 auto" }}
                    size={20}
                    color={"#e03c31"}
                    loading={isLoading}
                  />
                </div>
              </div>
            ) : controlType === "table" ? (
              <GenericTable
                columns={columns}
                data={tableData}
                section="sale-sheet-classifications"
                pageSize={10}
                enablePagination={true}
                meta={{
                  updateData: updateRowData,
                  handleSave,
                  handleDelete,
                }}
              />
            ) : renderList(data)}
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className="SaleSheetClassificationList">
      {isAuthenticated ? renderComponent() : null}
    </div>
  );
}

export default SaleSheetClassificationList;